import { TFunction } from "i18next";

import { EventTypeCellParts, EventTypeStrategy } from "./EventTypeStrategy";
import { getTranslatedEventTypeName } from "../../utils/eventTypeUtils";

import { TransactionType } from "@/types/transaction/TransactionType";

function hasMonthData(month?: string): boolean {
  if (!month) return false;
  const date = new Date(month);
  return date.getFullYear() > 1;
}

export class BudgetCreatedEventTypeStrategy implements EventTypeStrategy {
  renderCell(row: TransactionType, t: TFunction): JSX.Element {
    if (!hasMonthData(row.eventData.month)) {
      return (
        <>
          {t(`eventTypes.${row.eventType}`)}
          {" "}
          <i>({t("common.historicalEventNoDetails")})</i>
        </>
      );
    }
    return (
      <>
        {t(`eventTypes.${row.eventType}`)}
        {" "}
        {t("common.in")}{" "}
        <b>
          {new Date(row.eventData.month!).toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
          })}
        </b>
      </>
    );
  }

  getTypeAndDescription(
    row: TransactionType,
    t: TFunction,
  ): EventTypeCellParts {
    if (!hasMonthData(row.eventData.month)) {
      return {
        type: <>{getTranslatedEventTypeName(row.eventType, t)}</>,
        description: <i>{t("common.historicalEventNoDetails")}</i>,
      };
    }
    return {
      type: <>{getTranslatedEventTypeName(row.eventType, t)}</>,
      description: (
        <>
          {" "}
          {t("common.in")}{" "}
          <b>
            {new Date(row.eventData.month!).toLocaleDateString("en-US", {
              month: "long",
              year: "numeric",
            })}
          </b>
        </>
      ),
    };
  }
}
